/**
 * HeroClouds — decorative cloud layers matching the Webflow homepage hero.
 * Drop this inside any `position: relative; overflow: hidden` hero section.
 */
export default function HeroClouds() {
  return (
    <div className="hero-clouds" aria-hidden="true">
      <div className="clouds-xsmall" />
      <div className="clouds-small" />
      <div className="clouds-medium" />
      <div className="clouds-large" />
    </div>
  )
}
